import React from 'react';
import { NumericFormatProps } from 'react-number-format';
import { IntRangeString } from '@payer-admin-ui/components-v2/src/functions/numbers';
import { Box, Typography } from '@mui/material';
import { extendedNumberFormat, ExtendedNumberFormat } from './ExtendedNumberFormat';

const CurrencyCodeFormat = ({ code }: { code: string }) => (
  <Typography
    component="span"
    sx={{
      fontSize: '0.85em',
      fontWeight: 600,
      color: 'currencyCode.main',
    }}
  >
    {code.toUpperCase()}
  </Typography>
);

export type AmountFormatProps = {
  amount: number;
  currencyCode?: string;
  fractionDigits?: IntRangeString;
  nullable?: boolean;
  isCents?: boolean;
} & NumericFormatProps;

const AmountFormat = ({
  amount,
  currencyCode,
  fractionDigits = '2',
  nullable = false,
  isCents = true,
  ...props
}: AmountFormatProps) => {
  return (
    <Box display="inline-flex" alignItems="baseline">
      <ExtendedNumberFormat
        {...props}
        value={isCents ? amount / 100 : amount}
        fractionDigits={fractionDigits}
        nullable={nullable}
      />
      {currencyCode && (
        <>
          {' '}
          <Box component="span" sx={{ ml: 0.5 }}>
            <CurrencyCodeFormat code={currencyCode} />
          </Box>
        </>
      )}
    </Box>
  );
};

const amountFormat = (
  value: number,
  {
    currencyCode,
    fractionDigits = '2',
    isCents = true,
  }: {
    currencyCode?: string;
    fractionDigits?: IntRangeString;
    isCents?: boolean;
  } = {},
) => {
  return (
    extendedNumberFormat(isCents ? value / 100 : value, { fractionDigits }) +
    (currencyCode ? ` ${currencyCode.toUpperCase()}` : '')
  );
};

export { AmountFormat, amountFormat, CurrencyCodeFormat };
